module.exports = __webpack_public_path__ + "img/astrick-logo.6ab71f20.svg";